const sizes = { sm: 'w-4 h-4 border-2', md: 'w-6 h-6 border-2', lg: 'w-8 h-8 border-[3px]', xl: 'w-12 h-12 border-4' };
const colors = { primary: 'border-primary border-t-transparent', white: 'border-white border-t-transparent', gray: 'border-gray-400 border-t-transparent' };

const Spinner = ({ size = 'md', color = 'primary', className = '', ...props }) => (
  <div className={`${sizes[size] || sizes.md} ${colors[color] || colors.primary} rounded-full animate-spin ${className}`} role="status" {...props}>
    <span className="sr-only">Loading...</span>
  </div>
);

Spinner.Overlay = ({ size = 'lg', color = 'primary', message, className = '' }) => (
  <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
    <Spinner size={size} color={color} />
    {message && <p className="text-sm text-gray-500 font-medium">{message}</p>}
  </div>
);

Spinner.FullPage = ({ message = 'Loading...' }) => (
  <div className="fixed inset-0 flex items-center justify-center bg-white/80 z-50">
    <Spinner.Overlay size="xl" message={message} />
  </div>
);

export default Spinner;
